import { useState } from "react";
import { portraitSrc } from "@/lib/buddy";

export const BuddyAvatar = ({ buddy, className = "w-10 h-10", testId = "buddy-avatar" }) => {
  const [broken, setBroken] = useState(false);
  const src = portraitSrc(buddy);
  if (src && !broken) return <img src={src} alt={buddy.name} onError={() => setBroken(true)} data-testid={testId} className={`${className} rounded-full object-cover shrink-0`} />;
  return (
    <span data-testid={testId} className={`${className} rounded-full bg-[#6B9080] grid place-items-center text-white font-display shrink-0`}>
      {(buddy?.name || "B")[0].toUpperCase()}
    </span>
  );
};
